"use strict";

angular.module("customer")
.controller("CustomerEdit", function(
    $rootScope, $scope, $state, $resource, $http, $timeout, FlashBag, gettextCatalog, FormError, UserService,
    PatternService, CUSTOMER_TYPE_REGISTRATION, CUSTOMER_TYPE, SETVALIDITY_DIGEST_TIMEOUT_DELAY, appConfig
) {
    var _this = this;
    var service = $resource(appConfig.API_SERVER + "/auth/customer/edit/");
    $scope.User = {};
    $scope.isArray = angular.isArray;
    $scope.isCustomerTypeBusiness = false;
    $scope.pattern = PatternService;

    function applyShippingAndBillingSameAddress() {
        if ($scope.shippingIsSameAsBilling) {
            $scope.User.BillingAddress = $scope.User.ShippingAddress;
            $scope.User.BillingCity = $scope.User.ShippingCity;
            $scope.User.BillingProvinceName = $scope.User.ShippingProvinceName;
            $scope.User.BillingProvinceCode = $scope.User.ShippingProvinceCode;
            $scope.User.BillingPostalCode = $scope.User.ShippingPostalCode;
            $scope.User.BillingCountryName = $scope.User.ShippingCountryName;
            $scope.User.BillingCountryCode = $scope.User.ShippingCountryCode;
        }
    }

    $scope.$watch("shippingIsSameAsBilling", function(newValue, oldValue) {
        if (oldValue == null) return; // return when the first load is done

        if (newValue) {
            applyShippingAndBillingSameAddress();
        }
        else {
            $scope.User.BillingAddress = "";
            $scope.User.BillingCity = "";
            $scope.User.BillingProvinceName = "";
            $scope.User.BillingProvinceCode = "";
            $scope.User.BillingPostalCode = "";
            $scope.User.BillingCountryName = "";
            $scope.User.BillingCountryCode = "";
        }
    });

    $scope.validate = function() {
        FlashBag.clearAll();
        if ($scope.FormRetailerEdit && $scope.FormRetailerEdit.website_url) {
            $scope.FormRetailerEdit.website_url.$setValidity("pattern", true);
        }
        applyShippingAndBillingSameAddress();

        $timeout(function() {
            if (!$scope.FormRetailerEdit.$valid) {
                $scope.isFormSubmit = true;
                FormError.focus("FormRetailerEdit");
            }
            else {
                _this.validateZoneKey();
            }
        }, SETVALIDITY_DIGEST_TIMEOUT_DELAY);

    };

    function setShippingIsSameAsBillingAddress() {
        $scope.shippingIsSameAsBilling = (
            $scope.User.ShippingCountryName === $scope.User.BillingCountryName
            && $scope.User.ShippingCountryCode === $scope.User.BillingCountryCode
            && $scope.User.ShippingProvinceName === $scope.User.BillingProvinceName
            && $scope.User.ShippingProvinceCode === $scope.User.BillingProvinceCode
            && $scope.User.ShippingAddress === $scope.User.BillingAddress
            && $scope.User.ShippingCity === $scope.User.BillingCity
            && $scope.User.ShippingPostalCode === $scope.User.BillingPostalCode
        );
    }

    $scope.Form = service.get(
        function onSuccess(data) {
            $scope.isCustomerTypeBusiness = $scope.Form.type === CUSTOMER_TYPE["BUSINESS"];
            $scope.User.ShippingCountryName = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.CountryName : "";
            $scope.User.ShippingCountryCode = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.CountryCode : "";
            $scope.User.ShippingProvinceName = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.ProvinceName : "";
            $scope.User.ShippingProvinceCode = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.ProvinceCode : "";
            $scope.User.ShippingAddress = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.Address : "";
            $scope.User.ShippingCity = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.City : "";
            $scope.User.ShippingPostalCode = $scope.Form.ShipTo_Address ? $scope.Form.ShipTo_Address.PostalCode : "";

            $scope.User.BillingCountryName = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.CountryName : "";
            $scope.User.BillingCountryCode = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.CountryCode : "";
            $scope.User.BillingProvinceName = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.ProvinceName : "";
            $scope.User.BillingProvinceCode = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.ProvinceCode : "";
            $scope.User.BillingAddress = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.Address : "";
            $scope.User.BillingCity = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.City : "";
            $scope.User.BillingPostalCode = $scope.Form.BillTo_Address ? $scope.Form.BillTo_Address.PostalCode : "";

            setShippingIsSameAsBillingAddress();

            $scope.msgSupportCreateCustomer = $scope.isCustomerTypeBusiness ? gettextCatalog.getString("To create a new company, please contact support.")
                                                                            : gettextCatalog.getString("To manage another house with the same user account, please contact support.");

        },
        function onError(response) {
            FlashBag.apiError(response);
        }
    );

    this.validateZoneKey = function() {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/market/zones/build/",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                city: $scope.User.ShippingCity,
                province: $scope.User.ShippingProvinceName,
                postalCode: $scope.User.ShippingPostalCode,
                countryName: $scope.User.ShippingCountryName
            })
        }).then(
            function success(resp) {
                if (resp.data.split(";").length >= 3) {
                    _this.zoneKeyData = resp.data;
                    submit();
                }
                else {
                    FlashBag.preformattedError(gettextCatalog.getString("Your address is difficult to validate. Pay attention to the spelling with the displayed language or write us to support@wego.trade to assist you."), false);
                }
            },
            function failed(resp) {
                FlashBag.apiError(resp);
            }
        );
    };

    this.saveZoneKey = function(key, objID) {
        return $http({
            url: appConfig.API_SERVER + "/market/zones/save/",
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                refID: objID,
                refType: "retailer",
                zonesKey: key
            })
        }).then(
            function success(resp) {
                return resp;
            },
            function failed(resp) {
                FlashBag.apiError(resp);
                return resp;
            }
        );
    };

    function submit() {
        if (!$scope.Form.ShipTo_Address) {
            $scope.Form.ShipTo_Address = {};
        }

        $scope.Form.ShipTo_Address.CountryName = $scope.User.ShippingCountryName;
        $scope.Form.ShipTo_Address.CountryCode = $scope.User.ShippingCountryCode;
        $scope.Form.ShipTo_Address.ProvinceName = $scope.User.ShippingProvinceName;
        $scope.Form.ShipTo_Address.ProvinceCode = $scope.User.ShippingProvinceCode;
        $scope.Form.ShipTo_Address.Address = $scope.User.ShippingAddress;
        $scope.Form.ShipTo_Address.City = $scope.User.ShippingCity;
        $scope.Form.ShipTo_Address.PostalCode = $scope.User.ShippingPostalCode;

        if (!$scope.Form.BillTo_Address)
            $scope.Form.BillTo_Address = {};

        $scope.Form.BillTo_Address.CountryName = $scope.User.BillingCountryName;
        $scope.Form.BillTo_Address.CountryCode = $scope.User.BillingCountryCode;
        $scope.Form.BillTo_Address.ProvinceName = $scope.User.BillingProvinceName;
        $scope.Form.BillTo_Address.ProvinceCode = $scope.User.BillingProvinceCode;
        $scope.Form.BillTo_Address.Address = $scope.User.BillingAddress;
        $scope.Form.BillTo_Address.City = $scope.User.BillingCity;
        $scope.Form.BillTo_Address.PostalCode = $scope.User.BillingPostalCode;

        $scope.Form.$save().then(
            function onSuccess(data) {
                if ($scope.FormRetailerEdit && $scope.FormRetailerEdit.website_url) {
                    $scope.FormRetailerEdit.website_url.$setValidity("pattern", true);
                }

                $scope.isSubmit = false;
                $scope.Form = data;
                FlashBag.success(gettextCatalog.getString("The customer information was updated successfully."), true);
                _this.saveZoneKey(_this.zoneKeyData, $scope.Form.id).then(function onSuccess() {
                    UserService.refreshCurrentUser().then(function onSuccess() {
                        if (
                            $rootScope.fromState && $rootScope.fromState.name
                            && (
                                $rootScope.fromState.name !== "registration"
                                && $rootScope.fromState.name !== "full-registration"
                            )
                        ) {
                            $state.go($rootScope.fromState, $rootScope.fromParams || {});
                        }
                        else {
                            $state.go("home");
                        }
                    });
                });
            },
            function onError(response) {
                FlashBag.apiError(response);
                if ($scope.FormRetailerEdit && $scope.FormRetailerEdit.website_url) {
                    var is_website_url_valid = !response.data.website_url;
                    $scope.FormRetailerEdit.website_url.$setValidity("pattern", is_website_url_valid);
                }
                $timeout(function() {
                    FormError.focus("FormRetailerEdit");
                }, SETVALIDITY_DIGEST_TIMEOUT_DELAY);
            }
        );
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/customer.controller.js
// module id = 897
// module chunks = 0